import { useRef, useState, useMemo } from 'react';

import useDispatch from 'shared/hooks/useDispatch';
import useSelector from 'shared/hooks/useSelector';

import caseLevelsAdapter from 'shared/utils/common-cases/caseLevelsAdapter';
import getCaseLevels2BasedOnCaseLevel1 from 'shared/utils/common-cases/getCaseLevels2BasedOnCaseLevel1';
import { selectCaseLevels1, selectCaseLevels2 } from '../../selectors';
import { setCaseLevels } from '../../slice';

import Button from '@mui/material/Button';
import CaseMenu from 'components/controls/case-menu';

import UserCommonCaseCreateForm from '../UserCommonCaseCreateForm';

const DropdownButton = () => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [showedCaseCreateForm, showCaseCreateForm] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const dispatch = useDispatch();

  const caseLevels1 = useSelector(selectCaseLevels1);
  const caseLevels2 = useSelector(selectCaseLevels2);

  const handleClickOpenButton = () => {
    if (caseLevels1.length) {
      setOpenDropdown(true);
    } else {
      showCaseCreateForm(true);
    }
  };

  const handleCloseCaseCreateForm = () => {
    showCaseCreateForm(false);
  };

  const handleCloseDropdown = () => {
    setOpenDropdown(false);
  };

  const options = useMemo(() => {
    return caseLevelsAdapter(caseLevels1, (caseLevel1) => ({
      children: caseLevelsAdapter(
        getCaseLevels2BasedOnCaseLevel1(caseLevel1.Value, caseLevels2),
        (caseLevel2) => ({
          children: [],
          action: () => {
            dispatch(
              setCaseLevels({
                caseLevel1: caseLevel1.Value,
                caseLevel2: caseLevel2.Value,
              })
            );

            handleCloseDropdown();
            showCaseCreateForm(true);
          },
        })
      ),
    }));
  }, [dispatch, caseLevels1, caseLevels2]);

  return (
    <>
      <Button
        ref={buttonRef}
        color="success"
        sx={{ fontWeight: 600 }}
        onClick={handleClickOpenButton}
      >
        UUSI PALVELUPYYNTÖ
      </Button>
      <CaseMenu
        open={openDropdown}
        anchorEl={buttonRef.current}
        options={options}
        handleClose={handleCloseDropdown}
      />
      {showedCaseCreateForm && (
        <UserCommonCaseCreateForm onClose={handleCloseCaseCreateForm} />
      )}
    </>
  );
};

export default DropdownButton;
